import type { ReactNode } from 'react';
import { Monitor, Paper, Scanner, artStyle } from './parts';

/** A scanning station: Paige Scan's own scan window (no browser), a job chosen and one big Scan button. */
export function StationArt({ width = 280 }: { width?: number }): ReactNode {
  return (
    <svg
      className="scan-art"
      viewBox="0 0 280 180"
      style={artStyle(width)}
      aria-hidden="true"
      focusable="false"
    >
      <Monitor x={10} y={34}>
        <rect className="sa-body" x="22" y="14" width="84" height="62" rx="5" />
        <path className="sa-ink" d="M30 24h22" />
        <rect className="sa-shade" x="30" y="32" width="68" height="12" rx="3" />
        <path className="sa-ink" d="M36 38h30" opacity="0.6" />
        <rect className="sa-accent" x="44" y="52" width="40" height="15" rx="7.5" />
        <path className="sa-on-accent" d="M56 59.5h16" />
      </Monitor>
      <path className="sa-trail" d="M168 112 C 156 86, 150 84, 120 94" />
      <Paper x={142} y={80} r={-12} w={18} h={23} tone={2} lines={false} className="sa-float" />
      <Scanner x={170} y={46} />
    </svg>
  );
}
